import { useMemo, useState, useEffect } from 'react';
import { transformProduct } from '@/utils/products';
import { productsForOrder } from '@/store/cart';
import useBundleOffersSummary from '@/hooks/useBundleOffersSummary';
import useProductTags from '@/hooks/useProductTags';

export default function useSimilarAndFrequentProducts(frequentlyBoughtTogetherApiRes, similarProductsApiRes) {
  const [productsOrder, setProductsOrder] = useState();
  const { productTags } = useProductTags();
  const { bundleOffersSummary } = useBundleOffersSummary();
  useEffect(() => {
    const productsForOrder$ = productsForOrder.subscribe(setProductsOrder);

    // eslint-disable-next-line
    return () => {
      productsForOrder$.unsubscribe();
    };
  }, []);

  const frequent = useMemo(() => {
    if (!frequentlyBoughtTogetherApiRes || !frequentlyBoughtTogetherApiRes.length) return null;

    return frequentlyBoughtTogetherApiRes.map(p => ({
      ...p,
      ...transformProduct(p, null, undefined, productTags, bundleOffersSummary),
    }));
  }, [frequentlyBoughtTogetherApiRes, productsOrder]);

  const similar = useMemo(() => {
    if (!similarProductsApiRes || !similarProductsApiRes.length) return null;

    return similarProductsApiRes.map(p => ({
      ...p,
      ...transformProduct(p, null, undefined, productTags, bundleOffersSummary),
    }));
  }, [similarProductsApiRes, productsOrder]);

  return { frequent, similar };
}
